import React from "react";

import styles from "./style.module.scss";

import instagramLogo from "assets/images/instalogo.png";
import facebookLogo from "assets/images/fblogo.png";
import telegram from "assets/images/telegram.png";
import sideLogotype from "assets/images/sideLogo2.png";

const Contacts = () => (
  <div id="contact" className={styles.contact}>
    <div className={styles.contact__toppanel} />

    <div className={styles.contact__wrapper}>
      <img
        className={styles.contact__sidelogo}
        src={sideLogotype}
        alt="sideLogo2.png"
      />
      <div className={styles.contact__text}>
        <div>
          <h2>Контакты:</h2>

          <a
            className={styles.contact__mail}
            href="mailto: formulatsvetaby.23@gmail.com"
          >
            formulatsvetaby.23@gmail.com
          </a>
          <br />
          <a className={styles.contact__telefon} href="tel:+375 25 796-16-36">
            +375 25 796-16-36
          </a>
        </div>

        <div className={styles.text__address}>
          <h2>Адрес:</h2>

          <address>
            <a href="https://maps.app.goo.gl/AEWNJXc954Nhhng89?g_st=it">
              ул. Московская 402, Брест, Брестская область 224004, Беларусь
            </a>
          </address>

          <div className={styles.contact__media}>
            <a
              href="https://www.instagram.com/formula_tsveta_by"
              target="_blank"
              rel="noreferrer"
            >
              <img src={instagramLogo} alt="instalogo.png" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61557042123639"
              target="_blank"
              rel="noreferrer"
            >
              <img src={facebookLogo} alt="fblogo.png" />
            </a>
            <a href="https://t.me/+375257961636" target="_blank" rel="noreferrer">
              <img src={telegram} alt="telegramLogo" />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.contact__panel}>
        <div className={styles.contact__shadowbar1} />
        <iframe
          title="Google Maps - Formula Tsveta Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2450.308160566229!2d23.791556099999998!3d52.1105216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47210fb6615c0fb3%3A0xf7e5bdd4548ed373!2z0KjQuNC90L7QvNC-0L3RgtCw0LYgItCd0LAg0JLQvtGB0YLQvtC60LUi!5e0!3m2!1sru!2sby!4v1764201108885!5m2!1sru!2sby"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <div className={styles.contact__shadowbar2} />
      </div>
    </div>
    <div className={styles.contact__botpanel} />
  </div>
);
export default Contacts;
